import { CdkDrag, CdkDropList, DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule, DatePipe, KeyValuePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterModule } from '@angular/router';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormlyModule } from '@ngx-formly/core';
import { AuthGuardDirective } from '@services/auth-guard.directive';
import { ButtonDatePickerComponent } from '@shared//components/chitin/molecules/button-date-picker/button-date-picker.component';
import { BrightViewSaveViewComponent } from '@shared/components/brightview/save-view/brightview-save-view.component';
import { BrightViewGalleryComponent } from '@shared/components/brightview/view-gallery/data-view-gallery.component';
import { ChartsBaseComponent } from '@shared/components/charts/base/charts-base.component';
import { ChitinButtonComponent } from '@shared/components/chitin/atoms/button/button.component';
import { ChitinCheckInputGroupComponent } from '@shared/components/chitin/atoms/check-input-group/check-input-group.component';
import { ChitinCheckboxComponent } from '@shared/components/chitin/atoms/checkbox/checkbox.component';
import { ChitinChipsInputComponent } from '@shared/components/chitin/atoms/chips-input/chips-input.component';
import { ChitinColorPickerComponent } from '@shared/components/chitin/atoms/color-picker/color-picker.component';
import { ChitinFormInputComponent } from '@shared/components/chitin/atoms/form-input/form-input.component';
import { ChitinIconComponent } from '@shared/components/chitin/atoms/icon/chitin-icon.component';
import { ChitinSelectOldComponent } from '@shared/components/chitin/atoms/select-old/select-old.component';
import { ChitinSelectComponent } from '@shared/components/chitin/atoms/select/select.component';
import { ChitinSpinnerComponent } from '@shared/components/chitin/atoms/spinner/chitin-spinner.component';
import { ChitinAccordionComponent } from '@shared/components/chitin/molecules/accordion/accordion.component';
import { ChitinDateRangePickerComponent } from '@shared/components/chitin/molecules/daterange-picker/daterange-picker.component';
import { ChitinRangeInputComponent } from '@shared/components/chitin/molecules/range-input/range-input.component';
import { ClaimFlagsDetailComponent } from '@shared/components/claim-flags-detail/claim-flags-detail.component';
import { ClaimFlagsComponent } from '@shared/components/claim-flags/claim-flags.component';
import { CodeAreaComponent } from '@shared/components/code-area/code-area.component';
import { CodeDiffViewerComponent } from '@shared/components/code-diff-viewer/code-diff-viewer.component';
import { CopyToClipboardButtonComponent } from '@shared/components/copy-to-clipboard-button/copy-to-clipboard-button.component';
import { DataGridComponent } from '@shared/components/data-grid/data-grid.component';
import { DataGridFilterComponent } from '@shared/components/data-grid/filter/data-grid-filter.component';
import { CursorPaginatorComponent } from '@shared/components/data-table/cursor-paginator/cursor-paginator.component';
import { DashboardPaginatorComponent } from '@shared/components/data-table/dashboard-paginator/dashboard-paginator.component';
import { InfiniscrollCursorPaginatorComponent } from '@shared/components/data-table/infiniscroll-cursor-paginator/infiniscroll-cursor-paginator.component';
import { InfiniscrollPaginatorComponent } from '@shared/components/data-table/infiniscroll-paginator/infiniscroll-paginator.component';
import { PaginatorComponent } from '@shared/components/data-table/paginator/paginator.component';
import { DataViewAddFilterComponent } from '@shared/components/data-view/add-filter/data-view-add-filter.component';
import { DataViewEditColumnsComponent } from '@shared/components/data-view/edit-columns/data-view-edit-columns.component';
import { DataViewFilterGalleryComponent } from '@shared/components/data-view/filter-gallery/data-view-filter-gallery.component';
import { DataMapFiltersComponent } from '@shared/components/data-view/filters/data-map-filters.component';
import { DataViewFiltersComponent } from '@shared/components/data-view/filters/data-view-filters.component';
import { DataViewGridComponent } from '@shared/components/data-view/grid/data-view-grid.component';
import { DataViewSaveViewComponent } from '@shared/components/data-view/save-view/data-view-save-view.component';
import { DataViewGalleryComponent } from '@shared/components/data-view/view-gallery/data-view-gallery.component';
import { DvViewActionsComponent } from '@shared/dataview/ui/view-actions/dv-view-actions.component';
import { DvViewTabsComponent } from '@shared/dataview/ui/view-tabs/dv-view-tabs.component';
import { ButtonDaterangePickerComponent } from '@shared/components/daterange-picker/button-daterange-picker/button-daterange-picker.component';
import { DaterangePickerComponent } from '@shared/components/daterange-picker/daterange-picker.component';
import { InputDaterangePickerComponent } from '@shared/components/daterange-picker/input-daterange-picker/input-daterange-picker.component';
import { ExportResultModalComponent } from '@shared/components/export-result-modal/export-result-modal.component';
import { FormFieldErrorsComponent } from '@shared/components/form-field-errors/form-field-errors.component';
import { FileValueAccessorDirective } from '@shared/components/forms/file-value-accessor.directive';
import { FormlyFieldButtonComponent } from '@shared/components/forms/formly-fields/formly-field-button.component';
import { FormlyFieldDateComponent } from '@shared/components/forms/formly-fields/formly-field-date.component';
import { FormlyFieldDaterangeComponent } from '@shared/components/forms/formly-fields/formly-field-daterange.component';
import { FormlyFieldErrorComponent } from '@shared/components/forms/formly-fields/formly-field-error.component';
import { FormlyFieldFileComponent } from '@shared/components/forms/formly-fields/formly-field-file.component';
import { FormlyFieldInputGroupComponent } from '@shared/components/forms/formly-fields/formly-field-input-group.component';
import { FormlyFieldInputComponent } from '@shared/components/forms/formly-fields/formly-field-input.component';
import { FormlyFieldPasswordComponent } from '@shared/components/forms/formly-fields/formly-field-password.component';
import { FormlyFieldPhoneComponent } from '@shared/components/forms/formly-fields/formly-field-phone.component';
import { FormlyFieldSelectComponent } from '@shared/components/forms/formly-fields/formly-field-select.component';
import { InputDatePickerComponent } from '@shared/components/forms/input-date-picker/input-date-picker.component';
import { InputDateRangePickerComponent } from '@shared/components/forms/input-date-range-picker/input-date-range-picker.component';
import { LoadingSpinnerComponent } from '@shared/components/loading-spinner/loading-spinner.component';
import { FooterComponent } from '@shared/components/new/footer/footer.component';
import { PageHeaderComponent } from '@shared/components/new/page-header/page-header.component';
import { PlaceholderComponent } from '@shared/components/new/placeholder/placeholder.component';
import { SidebarCtaComponent } from '@shared/components/new/sidebar-cta/sidebar-cta.component';
import { SidebarComponent } from '@shared/components/new/sidebar/sidebar.component';
import { TablePlaceholderComponent } from '@shared/components/new/table-placeholder/table-placeholder.component';
import { PageNotFoundComponent } from '@shared/components/page-not-found/page-not-found.component';
import { PdfViewerComponent } from '@shared/components/pdf-viewer/pdf-viewer.component';
import { PerfectScrollbarComponent, PerfectScrollbarDirective } from '@shared/components/perfect-scrollbar/perfect-scrollbar';
import { PharmacyDotComponent } from '@shared/components/pharmacy/pharmacy-dot/pharmacy-dot.component';
import { RxDashboardCCRDataViewComponent } from '@shared/components/rx-dashboard/ccr-dataview/rx-dashboard-ccr-dataview.component';
import { SignaturePadComponent } from '@shared/components/signature-pad/signature-pad.component';
import { SliderComponent } from '@shared/components/slider/slider.component';
import { SquareCheckmarkComponent } from '@shared/components/square-checkmark/square-checkmark.component';
import { TenantLogoComponent } from '@shared/components/tenant-logo/tenant-logo.component';
import { ThemeToggleComponent } from '@shared/components/theme-toggle/theme-toggle.component';
import { ToggleCardComponent } from '@shared/components/toggle-card/toggle-card.component';
import { VerifyAccountInfoComponent } from '@shared/components/verify-account-info/verify-account-info.component';
import { ClickOutsideDirective } from '@shared/directives/click-outside.directive';
import { MaskDirective } from '@shared/directives/mask.directive';
import { TypedTemplateDirective } from '@shared/directives/typed-template.directive';
import { EmptyPipe } from '@shared/pipes/empty.pipe';
import { GetPipe } from '@shared/pipes/get';
import { GridFieldPipe } from '@shared/pipes/grid-field.pipe';
import { GroupByPipe } from '@shared/pipes/group-by.pipe';
import { HighlightCodePipe } from '@shared/pipes/highlight-code.pipe';
import { JoinPipe } from '@shared/pipes/join.pipe';
import { MaskifyPipe } from '@shared/pipes/maskify.pipe';
import { OrdinalPipe } from '@shared/pipes/ordinal.pipe';
import { PageTotalPipe } from '@shared/pipes/page-total.pipe';
import { PhoneWithSpacesPipe } from '@shared/pipes/phone-with-spaces.pipe';
import { PhonePipe } from '@shared/pipes/phone.pipe';
import { ReplaceTokensPipe } from '@shared/pipes/replace-tokens.pipe';
import { SafePipe } from '@shared/pipes/safe.pipe';
import { StatusLabelPipe } from '@shared/pipes/status-label.pipe';
import { TimeDurationPipe } from '@shared/pipes/time-duration.pipe';
import { TrendIconPipe } from '@shared/pipes/trend-icon.pipe';
import { TruncatePipe } from '@shared/pipes/truncate.pipe';
import { UserRolePipe } from '@shared/pipes/user-role.pipe';
import { FormFieldService } from '@shared/providers/form-field-service';
import { OpenSearchClient } from '@shared/providers/opensearch-client';
import { OpenSearchService } from '@shared/providers/opensearch.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { NgxPaginationModule } from 'ngx-pagination';

const declarations = [
  PerfectScrollbarComponent,
  PerfectScrollbarDirective,
  PhonePipe,
  PhoneWithSpacesPipe,
  GroupByPipe,
  PageTotalPipe,
  MaskifyPipe,
  VerifyAccountInfoComponent,
  SquareCheckmarkComponent,
  FormFieldErrorsComponent,
  ClickOutsideDirective,
  FooterComponent,
  PaginatorComponent,
  CursorPaginatorComponent,
  InfiniscrollPaginatorComponent,
  DashboardPaginatorComponent,
  InfiniscrollCursorPaginatorComponent,
  TimeDurationPipe,
  TruncatePipe,
  InputDatePickerComponent,
  InputDateRangePickerComponent,
  FormlyFieldPhoneComponent,
  FormlyFieldPasswordComponent,
  FormlyFieldSelectComponent,
  FormlyFieldInputComponent,
  FormlyFieldDateComponent,
  FormlyFieldDaterangeComponent,
  FormlyFieldButtonComponent,
  FormlyFieldInputGroupComponent,
  FormlyFieldErrorComponent,
  FormlyFieldFileComponent,
  FileValueAccessorDirective,
  CodeAreaComponent,
  DataGridComponent,
  DataGridFilterComponent,
  TypedTemplateDirective,
  SidebarComponent,
  SidebarCtaComponent,
  PlaceholderComponent,
  FooterComponent,
  PageHeaderComponent,
  TablePlaceholderComponent,
  JoinPipe,
  UserRolePipe,
  ChartsBaseComponent,
  SliderComponent,
  DataViewGridComponent,
  DataViewFiltersComponent,
  DataMapFiltersComponent,
  DataViewFilterGalleryComponent,
  DataViewAddFilterComponent,
  StatusLabelPipe,
  EmptyPipe,
  DataViewEditColumnsComponent,
  DataViewSaveViewComponent,
  DataViewGalleryComponent,
  TrendIconPipe,
  ChitinChipsInputComponent,
  SafePipe,
  PageNotFoundComponent,
  CodeDiffViewerComponent,
  ExportResultModalComponent,
  MaskDirective,
  OrdinalPipe,
  ClaimFlagsComponent,
  ClaimFlagsDetailComponent,
  HighlightCodePipe,
  BrightViewSaveViewComponent,
  BrightViewGalleryComponent,
  CopyToClipboardButtonComponent,
  RxDashboardCCRDataViewComponent,
  GetPipe,
  ReplaceTokensPipe,
];

const chitinImports = [
  ChitinButtonComponent,
  ChitinCheckboxComponent,
  ChitinFormInputComponent,
  ChitinCheckInputGroupComponent,
  ChitinSelectOldComponent,
  ChitinSelectComponent,
  ChitinSpinnerComponent,
  ChitinIconComponent,
  ChitinDateRangePickerComponent,
  ButtonDatePickerComponent,
  ChitinRangeInputComponent,
  ChitinAccordionComponent,
];

const imports = [
  AuthGuardDirective,
  CommonModule,
  FormsModule,
  NgbModule,
  NgSelectModule,
  RouterModule,
  NgxPaginationModule,
  FormlyModule,
  MonacoEditorModule,
  MatDatepickerModule,
  MatNativeDateModule,
  DragDropModule,
  CdkDropList,
  CdkDrag,
  ChitinColorPickerComponent,
  NgxMaskDirective,
  NgxMaskPipe,
  SignaturePadComponent,
  ToggleCardComponent,
  InfiniteScrollModule,
  LeafletModule,
  MatProgressBarModule,
  DaterangePickerComponent,
  ButtonDaterangePickerComponent,
  InputDaterangePickerComponent,
  PdfViewerComponent,
  LoadingSpinnerComponent,
  TenantLogoComponent,
  PharmacyDotComponent,
  GridFieldPipe,
  DvViewActionsComponent,
  DvViewTabsComponent,
];

@NgModule({
  declarations,
  imports: [
    ...imports,
    ...chitinImports,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    ThemeToggleComponent,
  ],
  exports: [...imports, ...chitinImports, ...declarations, DatePipe, ReactiveFormsModule],
  providers: [
    provideNgxMask(),
    NgbActiveModal,
    FormFieldService,
    OpenSearchClient,
    OpenSearchService,
    DatePipe,
    StatusLabelPipe,
    TimeDurationPipe,
    KeyValuePipe,
    HighlightCodePipe,
  ],
})
export class SharedModule {}
